export const TOAST_AUTO_CLOSE = 4000;
